import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { CommonDialogComponent } from '../../erp/shared/common-dialog/common-dialog.component';

@Component({
  selector: 'ngx-html-container',
  templateUrl: './html-container.component.html',
  styleUrls: ['./html-container.component.scss']
})
export class HtmlContainerComponent implements OnInit {

  @Input() html: string;
  @Input() closeBtnText = 'Close';
  @Input() okText = 'Ok';
  @Input() cancelText = null;

  @Output() response = new EventEmitter<any>();

  htmlData: string = '';

  constructor(public ref: NbDialogRef<CommonDialogComponent>) { }

  ngOnInit(): void {
    this.htmlData = `data:text/html;charset=utf-8,${encodeURIComponent(this.html)}`
  }

  ok() {
    this.response.emit({ ok: true });
    this.ref.close({ ok: true });
  }

  cancel() {
    this.response.emit({ cancel: true });
    this.ref.close({ cancel: true });
  }
  
}
